export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind} from 'kpc';
import type {MessageSendPayload} from 'kpc';

interface Props {
    value?: string
    generating?: boolean
}

export default class extends Component<Props> {
    static template = template;

    private timer: any = null;

    static defaults() {
        return {value: '', generating: false};
    }

    @bind
    onMessageSend(_payload: MessageSendPayload) {
        this.set('generating', true);
        this.timer = setTimeout(() => this.set('generating', false), 3000);
    }

    @bind
    onStopGenerate() {
        clearTimeout(this.timer);
        this.set('generating', false);
    }
}